export default "__VITE_ASSET__DuPAWNMV__"